export default __webpack_public_path__ + "static/media/confirmation-montage.880c8c59.svg";